import { OrganizationKeyName } from "../../../model/Organization";

export const GET_SHOP_LIST = "SHOP:GET_SHOP_LIST";

export const getShopListAction = (organization: OrganizationKeyName) => ({
  type: GET_SHOP_LIST as typeof GET_SHOP_LIST,
  organization,
});

export type GetShopListAction = ReturnType<typeof getShopListAction>;
